import { api, type ApiType } from 'lib/api';
import { stringParse } from 'utils';

export const apiCategories: ApiType = {
  get: {
    list: () => api.get('api/itemcategories?isActive=true&pageSize=100'),
    search: ({ query, vars }) =>
      api.get(stringParse('/api/itemcategories?search={0}&isActive=true', vars), query),
  },
  put: {},
  post: {},
  delete: {},
};
